var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11111 5.55556V7.77778H0V8.88889H1.66667V10H2.77778V8.88889H3.88889V10H5V8.86056C6.09333 8.72222 6.94444 7.79667 6.94444 6.66667C6.94444 5.93333 6.58333 5.28667 6.03333 4.88167C6.43897 4.46835 6.66635 3.91245 6.66667 3.33333C6.66667 2.30111 5.95611 1.43833 5 1.19V0H3.88889V1.11111H2.77778V0H1.66667V1.11111H0V2.22222H1.11111V5.55556ZM4.72222 7.77778H2.22222V5.55556H4.72222C5.335 5.55556 5.83333 6.05389 5.83333 6.66667C5.83333 7.27944 5.335 7.77778 4.72222 7.77778ZM2.22222 2.22222H4.44444C5.05722 2.22222 5.55556 2.72056 5.55556 3.33333C5.55556 3.94611 5.05722 4.44444 4.44444 4.44444H2.22222V2.22222Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcWhite);
export default __webpack_public_path__ + "static/media/btcWhite.615aed27c4498e314b603cfb21861314.svg";
export { ForwardRef as ReactComponent };